/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdateSecondPhoneNumberPayload } from 'api/actions/update-second-phone-number/update-second-phone-number-payload';
import { UpdateSecondPhoneNumberPathParameters } from 'api/actions/update-second-phone-number/update-second-phone-number-path-parameters';
import { UpdateSecondPhoneNumberResponse } from 'api/actions/update-second-phone-number/update-second-phone-number-response';

type UpdateSecondPhoneNumberQueryParameters = Record<string, any>;

/**
 * The path of the UpdateSecondPhoneNumber action.
 */
export const updateSecondPhoneNumberActionPath = new SweetPath<keyof UpdateSecondPhoneNumberPathParameters>(
  '/user/second-phone-number',
  { path: '{param}' }
);

/**
 * Creates a contextualized UpdateSecondPhoneNumber actions.
 */
export default function createUpdateSecondPhoneNumberAction(axios: AxiosInstance) {
  return function updateSecondPhoneNumberAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UpdateSecondPhoneNumberQueryParameters;
    payload: UpdateSecondPhoneNumberPayload;
  }) {
    const path = updateSecondPhoneNumberActionPath.original;

    return axios.put<UpdateSecondPhoneNumberResponse, UpdateSecondPhoneNumberResponse, UpdateSecondPhoneNumberPayload>(
      path,
      payload
    );
  };
}
